import { SensorData } from 'Simulations/SensorPoint';
import { StageParameters, TransformStage } from '../../Stage';

export interface CloudCoverageStageParams extends StageParameters {
    isCloudCoverOn: boolean;
    cloudCoverPercentage: number;
}

class CloudCoverageStage extends TransformStage<CloudCoverageStageParams> {
    override process(input: SensorData): SensorData {
        let value = input.getScalarValue();

        if (this.getParams().isCloudCoverOn) value *= 1 - this.getParams().cloudCoverPercentage;

        input.setScalarValue(value);
        return input;
    }
}

export default CloudCoverageStage;
